module.exports = "<p>\r\n  annoucments works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/annoucments/annoucments.component.html
// module id = ./src/app/home/annoucments/annoucments.component.html
// module chunks = main